enum AccessChangeNotice {
  RELOAD_PENDING = "reloadPending",
}

export default AccessChangeNotice;
